/* OYL Mobile Menu — v1.1 (April 2026)
 * Mobile-only drawer that hijacks Dawn's built-in hamburger as the trigger.
 * No custom fixed-position trigger → no positioning conflicts with the
 * announcement bar, and no mobile tap quirks (Dawn's <summary> is already
 * correctly styled and tappable in the header).
 */

(function(){
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var drawer      = document.getElementById('oyl-mobile-drawer');
    var backdrop    = document.getElementById('oyl-mobile-backdrop');
    var closeBtn    = document.getElementById('oyl-drawer-close');
    var searchTrigger = document.getElementById('oyl-search-trigger');
    var searchBack  = document.getElementById('oyl-search-back');
    var searchInput = document.getElementById('oyl-search-input');
    var searchClear = document.getElementById('oyl-search-clear');

    if (!drawer || !backdrop) return;

    function openMenu(){
      drawer.classList.add('open');
      backdrop.classList.add('open');
      document.body.classList.add('oyl-mobile-nav-active');
    }
    function closeMenu(){
      drawer.classList.remove('open');
      drawer.classList.remove('search-open');
      backdrop.classList.remove('open');
      document.body.classList.remove('oyl-mobile-nav-active');
    }
    function openSearch(){
      drawer.classList.add('search-open');
      setTimeout(function(){ if (searchInput) searchInput.focus(); }, 250);
    }
    function closeSearch(){
      drawer.classList.remove('search-open');
      if (searchInput) { searchInput.blur(); searchInput.value = ''; }
    }

    window.oylOpenMobileMenu  = openMenu;
    window.oylCloseMobileMenu = closeMenu;

    // ── Hook Dawn's hamburger as the trigger ─────────────────────────────
    // Dawn renders <details><summary class="header__icon--menu">...</summary>...</details>
    // We want taps to open OUR drawer, not toggle Dawn's <details>.
    // Use delegation on document so it works even if the header re-renders (e.g.
    // AJAX section refresh for cart changes). Mobile-only: at > 768px we don't
    // intercept, so Dawn's default behavior is preserved.
    document.addEventListener('click', function(e){
      if (window.innerWidth > 768) return;
      var summary = e.target.closest && e.target.closest('summary.header__icon--menu, .header__icon--menu');
      if (!summary) return;
      e.preventDefault();
      e.stopPropagation();
      // Force-close Dawn's details in case it was already open
      var details = summary.closest('details');
      if (details && details.open) details.open = false;
      openMenu();
    }, true); // capture phase so we run before Dawn's own handlers

    // Also close Dawn's drawer if it somehow opens (belt-and-braces)
    document.addEventListener('toggle', function(e){
      if (window.innerWidth > 768) return;
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('details') && e.target.querySelector('.header__icon--menu')) {
        if (e.target.open) {
          e.target.open = false;
          openMenu();
        }
      }
    }, true);

    // ── Close / search / escape wiring ───────────────────────────────────
    if (closeBtn)      closeBtn.addEventListener('click', closeMenu);
    if (backdrop)      backdrop.addEventListener('click', closeMenu);
    if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
    if (searchTrigger) searchTrigger.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSearch(); }
    });
    if (searchBack)    searchBack.addEventListener('click', closeSearch);
    if (searchClear)   searchClear.addEventListener('click', function(){
      if (searchInput) { searchInput.value = ''; searchInput.focus(); }
    });

    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      if (drawer.classList.contains('search-open')) closeSearch();
      else if (drawer.classList.contains('open')) closeMenu();
    });
  }
})();